import { render, staticRenderFns } from "./DesistenciaEmMassaV2.vue?vue&type=template&id=0761dbe5"
import script from "./DesistenciaEmMassaV2.vue?vue&type=script&lang=js"
export * from "./DesistenciaEmMassaV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports